async function requestJson(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  return data;
}

export async function fetchVehicleIngestionRuns(filters = {}) {
  const params = new URLSearchParams();
  if (filters.vehicleSourceId) params.set("vehicle_source_id", filters.vehicleSourceId);
  if (filters.runType) params.set("run_type", filters.runType);
  if (filters.runStatus) params.set("run_status", filters.runStatus);
  if (filters.limit) params.set("limit", String(filters.limit));
  const query = params.toString();
  const data = await requestJson(
    `/api/admin/mobility/vehicle-ingestion/runs${query ? `?${query}` : ""}`
  );
  return data.runs || [];
}

export async function fetchVehicleIngestionRunById(id) {
  const data = await requestJson(
    `/api/admin/mobility/vehicle-ingestion/runs/${encodeURIComponent(id)}`
  );
  return data.run;
}

export async function runVehicleTestIngestion(payload = {}) {
  const data = await requestJson("/api/admin/mobility/vehicle-ingestion/test-run", {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return data;
}

export async function runVehicleSourceTestIngestion(sourceId, payload = {}) {
  const data = await requestJson(
    `/api/admin/mobility/vehicle-sources/${encodeURIComponent(sourceId)}/test-ingestion`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    }
  );
  return data;
}
